import $ from 'cash-dom'
import Breakpoints from '../utils/breakpoints'

export default class MainNav {
  constructor({ $container } = {}) {
    this.$container = $container

    this.constructProps()

    this.constructElements()

    this.constructLanguages()

    this.constructEvents()

    this.$window.trigger('scroll')
  }

  static init() {
    const $containers = $(MainNav.selectors.container)

    if ($containers.length) {
      $containers.each((i, elem) => {
        const constructed = new MainNav({ $container: $(elem) })
      })
    }
  }

  constructElements() {
    this.$window = $(window)
    this.$document = $(document)
    this.$scrollDetect = $(MainNav.selectors.scrollDetect)
    this.$dropdown = this.$container.find(MainNav.selectors.dropdown)
    this.$dropdownInners = this.$container.find(MainNav.selectors.dropdownInner)
    this.$languages = this.$container.find(MainNav.selectors.languages)
  }

  constructEvents() {
    this.$window
      // .on('scroll', () => this.doAdjustBackground())
      .on('resize', () => this.handleResizeWindow())

    this.observer = new IntersectionObserver((entries) => this.handleScrollDetect({ entries }))

    this.$scrollDetect.each((index, element) => {
      this.observer.observe(element)
    })

    this.$container
      .on('click', MainNav.selectors.triggerMain, (e) => this.handleClickTriggerMain({ e }))
      .on('click', `${MainNav.selectors.item}`, (e) => this.handleClickItem({ e }))
      .on('click', MainNav.selectors.back, (e) => this.handleClickBack({ e }))
      .on('click', MainNav.selectors.languages, (e) => this.handleClickLanguages({ e }))
      .on('mouseover', MainNav.selectors.item, (e) => this.handleMouseoverItem({ e }))
      .on('mouseout', MainNav.selectors.item, (e) => this.handleMouseoutItem({ e }))
      .on('mouseover', MainNav.selectors.dropdown, (e) => this.handleMouseoverDropdown({ e }))
      .on('mouseout', MainNav.selectors.dropdown, (e) => this.handleMouseoutDropdown({ e }))
  }

  constructLanguages() {
    this.$languagesClone = this.$languages.clone()
      .addClass(MainNav.classes.languagesClone)
      .insertAfter(this.$languages)
  }

  constructProps() {
    this.curBreakpoint = Breakpoints.is()
  }

  doSetNavUnsticky() {
    this.$container.removeClass(MainNav.classes.sticky)
  }
  
  doSetNavSticky() {
    this.$container.addClass(MainNav.classes.sticky)
  }

  doCloseAll() {
    this.$container.removeClass(MainNav.classes.open)

    this.$dropdown.removeAttr('style')
  }

  doCloseLanguages() {
    this.$languagesClone.removeClass(MainNav.classes.languagesShow)
  }

  doCloseNav() {
    this.$container.removeClass(MainNav.classes.open)

    this.$document.off('click.mainNavLanguagesOff')
  }

  doHideNextPanel({ $item }) {
    this.doHidePanel({ $panel: $item.next() })
  }

  doHidePanel({ $panel }) {
    if (!Breakpoints.has('lg')) {
      return
    }

    this.$container.removeClass(MainNav.classes.open)

    // desktop actions
    $panel.css({ height: 0 })
  }

  doOpenLanguages() {
    this.$languagesClone.addClass(MainNav.classes.languagesShow)

    this.$document.on('click.mainNavLanguagesOff', `:not(${MainNav.classes.languagesClone})`, (e) => this.handleOffClickLanguages({ e }))
  }

  doOpenNav() {
    this.$container.addClass(MainNav.classes.open)
  }

  doShowNextPanel({ $item }) {
    this.doShowPanel({ $panel: $item.next() })
  }

  doShowPanel({ $panel }) {
    // mobile actions
    if (!Breakpoints.has('lg')) {
      $panel.addClass(MainNav.classes.dropdownShow)

      return
    }

    this.$container.addClass(MainNav.classes.open)

    // desktop actions
    $panel.css({ height: $panel.find(MainNav.selectors.dropdownInner).outerHeight() + 'px' })
  }

  doUnstick() {
    this.$container.addClass(MainNav.classes.unstick)
  }

  handleClickBack({ e }) {
    this.$dropdown.removeClass(MainNav.classes.dropdownShow)
  }

  handleClickLanguages({ e }) {
    if (!$(e.currentTarget).hasClass(MainNav.classes.languagesClone)) {
      e.preventDefault()

      e.stopPropagation()

      this.doOpenLanguages()
    }
  }

  handleClickItem({ e }) {
    // mobile actions
    if (!Breakpoints.has('lg')) {
      e.preventDefault()

      const $item = $(e.currentTarget)

      $item[0].blur()

      this.doShowNextPanel({ $item })
    }
  }

  handleClickTriggerMain({ e }) {
    e.preventDefault()

    if (this.$container.hasClass(MainNav.classes.open)) {
      this.doCloseNav()
    } else {
      this.doOpenNav()
    }
  }

  handleMouseoutDropdown({ e }) {
    // desktop actions
    if (Breakpoints.has('lg')) {
      this.doHidePanel({ $panel: $(e.currentTarget) })
    }
  }

  handleMouseoverDropdown({ e }) {
    // desktop actions
    if (Breakpoints.has('lg')) {
      this.doShowPanel({ $panel: $(e.currentTarget) })
    }
  }

  handleMouseoutItem({ e }) {
    // desktop actions
    if (Breakpoints.has('lg')) {
      this.doHideNextPanel({ $item: $(e.currentTarget) })
    }
  }

  handleMouseoverItem({ e }) {
    // desktop actions
    if (Breakpoints.has('lg')) {
      this.doShowNextPanel({ $item: $(e.currentTarget) })
    }
  }

  handleOffClickLanguages() {
    this.doCloseLanguages()
  }

  handleResizeWindow() {
    const curBreakpoint = Breakpoints.is()

    if (this.curBreakpoint !== curBreakpoint) {
      this.doCloseAll()

      this.curBreakpoint = curBreakpoint
    }
  }

  handleScrollDetect({ entries }) {
    if (!this.$container.hasClass(MainNav.classes.unstick)) {
      if (entries[0].isIntersecting) {
        this.doSetNavUnsticky()
      } else {
        this.doSetNavSticky()
      }
    }
  }
}

MainNav.selectors = {
  container: '.js-main-nav',
  scrollDetect: '.js-main-nav-scroll-detect',
  back: '.js-main-nav-back',
  dropdown: '.js-main-nav-dropdown',
  dropdownInner: '.js-main-nav-dropdown-inner',
  item: '.js-main-nav-item',
  languages: '.js-main-nav-languages',
  triggerMain: '.js-main-nav-trigger-main'
}

MainNav.classes = {
  open: 'c-main-nav--open',
  sticky: 'c-main-nav--sticky',
  unstick: 'c-main-nav--unstick',
  dropdownShow: 'c-main-nav__dropdown--show',
  languagesClone: 'c-main-nav__eyebrow-languages--clone',
  languagesShow: 'c-main-nav__eyebrow-languages--show'
}
